import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const LoadAnimateIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="2.5" cy="2.5" r="2.5" fill={fillColor || '#FF5C28'} />
      <circle cx="10.5" cy="2.5" r="2.5" fill={fillColor || '#FF5C28'} />
      <circle cx="18.5" cy="2.5" r="2.5" fill={fillColor || '#FF5C28'} />
      <circle cx="26.5" cy="2.5" r="2.5" fill={fillColor || '#FF5C28'} />
      <circle cx="34.5" cy="2.5" r="2.5" fill={fillColor || '#FF5C28'} />
      <circle cx="2.5" cy="10.5" r="2.5" fill={fillColor || '#FF5C28'} fillOpacity="0.4" />
      <circle cx="10.5" cy="10.5" r="2.5" fill={fillColor || '#FF5C28'} fillOpacity="0.15" />
      <circle cx="18.5" cy="10.5" r="2.5" fill={fillColor || '#FF5C28'} />
      <circle cx="26.5" cy="10.5" r="2.5" fill={fillColor || '#FF5C28'} />
      <circle cx="34.5" cy="10.5" r="2.5" fill={fillColor || '#FF5C28'} />
      <circle cx="2.5" cy="18.5" r="2.5" fill={fillColor || '#FF5C28'} />
      <circle cx="10.5" cy="18.5" r="2.5" fill={fillColor || '#FF5C28'} fillOpacity="0.4" />
      <circle cx="18.5" cy="18.5" r="2.5" fill={fillColor || '#FF5C28'} fillOpacity="0.15" />
      <circle cx="26.5" cy="18.5" r="2.5" fill={fillColor || '#FF5C28'} />
      <circle cx="34.5" cy="18.5" r="2.5" fill={fillColor || '#FF5C28'} />
      <circle cx="2.5" cy="26.5" r="2.5" fill={fillColor || '#FF5C28'} />
      <circle cx="10.5" cy="26.5" r="2.5" fill={fillColor || '#FF5C28'} fillOpacity="0.15" />
      <circle cx="18.5" cy="26.5" r="2.5" fill={fillColor || '#FF5C28'} fillOpacity="0.4" />
      <circle cx="26.5" cy="26.5" r="2.5" fill={fillColor || '#FF5C28'} />
      <circle cx="34.5" cy="26.5" r="2.5" fill={fillColor || '#FF5C28'} />
      <circle cx="2.5" cy="34.5" r="2.5" fill={fillColor || '#FF5C28'} />
      <circle cx="10.5" cy="34.5" r="2.5" fill={fillColor || '#FF5C28'} />
      <circle cx="18.5" cy="34.5" r="2.5" fill={fillColor || '#FF5C28'} fillOpacity="0.15" />
      <circle cx="26.5" cy="34.5" r="2.5" fill={fillColor || '#FF5C28'} fillOpacity="0.4" />
      <circle cx="34.5" cy="34.5" r="2.5" fill={fillColor || '#FF5C28'} />
    </svg>
  );
};

export { LoadAnimateIcon };
